import React from 'react';
import classNames from 'classnames';
import { excludeChildrenByType, findChildByType, renderChildren } from '@fiverr-private/ui_utils';
import { ModalHeaderProps } from '../types';
import { useModalContext } from '../ModalContext';
import { MODAL_CLOSE_BTN_ID } from '../constants';

import styles from './index.module.scss';

const ModalHeader = ({ children, floating = false }: ModalHeaderProps) => {
  const { centered } = useModalContext();
  const closeButton = findChildByType(children, MODAL_CLOSE_BTN_ID);
  const restOfChildren = excludeChildrenByType(children, MODAL_CLOSE_BTN_ID);

  return (
    <div className={classNames(styles.header, { [styles.floating]: floating })}>
      <div className={classNames(styles.titleContainer, { [styles.textAlignCenter]: centered })}>
        <h4 className={styles.title}>{renderChildren(restOfChildren)}</h4>
      </div>
      {renderChildren(closeButton)}
    </div>
  );
};

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
